//Ticket ADMIN-853 for "Waiting for Review" & "All Applications"
const specialUser = [
  "antonellagismundi@worldfamilyenglish.com",
  "junechen-external@worldfamilyenglish.com",
];

export const isSpecialUser = (user: string) => {
  return specialUser.includes(user.toLocaleLowerCase());
};

export const specialUserMarket = (user: string) => {
  const MKTOptionList = [
    { value: "TW", label: "TW" },
    { value: "HK", label: "HK" },
    { value: "KR", label: "KR" },
    { value: "JP", label: "JP" },
  ];

  const MKTOptions = specialUser.includes(user.toLocaleLowerCase())
    ? MKTOptionList.filter((option) => option.value !== "KR")
    : MKTOptionList;

  return MKTOptions;
};
